// Detect non-Latin scripts (Cyrillic, etc.) so names save in Latin without
// manual transliteration of registrations/team names.
// Hard block: callers use this to reject non-Latin name/team-name saves
// (Profile, registration gate, team naming) — not just a soft warning.

// A letter (any script) that is NOT Latin. Accented Latin (é, ü, ñ) is fine
// because it carries the Latin script property.
const NON_LATIN_LETTER = /(?=\p{L})(?!\p{Script=Latin})./u;

export function hasNonLatin(value: string): boolean {
  return NON_LATIN_LETTER.test(value);
}
